import { Grid, Typography } from "@mui/material";

import CoinSelectItem from "pages/Wallet/Component/FilterMarginHistory/Component/CoinSelectItem";
import DatePicker from "components/DatePicker";
import React from "react";
import Select from "components/Select";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function TradeOrderFilter() {
  const [searchParams, setSearchParams] = useSearchParams();

  const tradeForm = useSelector((state) => state.trade.tradeForm?.data);

  const defaultValues = {
    typeId: +searchParams.get("typeId") || 0,
    sideId: +searchParams.get("sideId") || 0,
    coinDestinationId: +searchParams.get("coinDestinationId") || -1,
    coinSourceId: +searchParams.get("coinSourceId") || -1,
    startDate: searchParams.get("startDate") || "",
    endDate: searchParams.get("endDate") || "",
  };

  const { watch, setValue } = useForm({ defaultValues });

  const handleChange = (value, fieldName) => {
    setValue(fieldName, value);
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: 1,
      [fieldName]: value,
    });
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Buy / Sell
        </Typography>

        <Select
          items={tradeForm?.lisSide}
          itemText="name"
          itemValue="id"
          value={watch("sideId")}
          onChange={(e) => handleChange(e.target.value, "sideId")}
          dir="ltr"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Destination Coin
        </Typography>

        <Select
          dir="ltr"
          items={tradeForm?.lisCoinDestination}
          itemText="name"
          itemValue="id"
          value={watch("coinDestinationId")}
          onChange={(e) => handleChange(e.target.value, "coinDestinationId")}
          customValue={(data) => <CoinSelectItem data={data} />}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Coin
        </Typography>

        <Select
          dir="ltr"
          items={tradeForm?.lisCoinSource}
          itemText="name"
          itemValue="id"
          value={watch("coinSourceId")}
          onChange={(e) => handleChange(e.target.value, "coinSourceId")}
          customValue={(data) => <CoinSelectItem data={data} />}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          State
        </Typography>

        <Select
          dir="ltr"
          items={tradeForm?.lisState}
          itemText="name"
          itemValue="id"
          value={watch("sideId")}
          onChange={(e) => handleChange(e.target.value, "sideId")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Type
        </Typography>

        <Select
          items={tradeForm?.lisType}
          itemText="name"
          itemValue="id"
          value={watch("typeId")}
          onChange={(e) => handleChange(e.target.value, "typeId")}
          dir="ltr"
        />
      </Grid>

      <Grid item xs={6} md={4}>
        <Typography variant="label" color="text.secondary">
          From Date
        </Typography>

        <DatePicker
          value={watch("startDate")}
          onChange={(e) => {
            handleChange(e, "startDate");
          }}
        />
      </Grid>

      <Grid item xs={6} md={4}>
        <Typography variant="label" color="text.secondary">
          To Date
        </Typography>

        <DatePicker
          value={watch("endDate")}
          onChange={(e) => {
            handleChange(e, "endDate");
          }}
        />
      </Grid>
    </Grid>
  );
}

export default TradeOrderFilter;
